import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';

import Section from '../components/section';

const IframeWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

const Video = ({
  rowOptions,
  title,
  url,
  className,
}) => url && (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      {title && (
        <Content>
          <h2>{title}</h2>
        </Content>
      )}
      <IframeWrapper>
        <iframe title={title} src={`https://www.youtube.com/embed/${url}?autoplay=0&autohide=1&rel=0`} frameBorder="0" />
      </IframeWrapper>
    </Container>
  </Section>
);

export default styled(Video)`

`;
